import { toast as baseToast } from 'react-toastify';

const removeToast = id => (
  baseToast.dismiss(`toast-message-${id}`)
);

export { removeToast };
